











































import Vue from 'vue'
import eventBus from '@/common/utils/eventBus'
import { APP_EVENTS, SYSTEM_ERROR } from '@/common/constants'
import RecommendationProducts from '@/common/components/RecommendationProducts.vue'
import { ProductType } from '@/types'
import { apolloClient } from '@/common/service/apolloClient'
import { PERSONALIZE_AREAS, PERSONALIZE_PAGES, PERSONALIZE_PATTERNS } from '@/common/const'
import { recommendedProductsQuery } from '@/product/queries'
import { BQ_AWS_PERSONALIZE_AREA_NAME, BQ_AWS_PERSONALIZE_LOGIC_TYPE, BQ_AWS_PERSONALIZE_PAGE_TYPE} from '@/common/utils'
import { checkCache } from '@/product/utils'
import scrollTo from '@/common/animatedScrollTo'

export default Vue.extend({
  components: {
    RecommendationProducts
  },
  data(): {
    isShow: boolean,
    isLoading: boolean,
    recommendedProductsOnOrderHistory: ProductType[],
    timeout: any,
    currentId: string
  } {
    return {
      isShow: false,
      isLoading: false,
      recommendedProductsOnOrderHistory: [],
      timeout: null,
      currentId: ''
    }
  },
  computed: {
    BQ_AWS_PERSONALIZE_LOGIC_TYPE() {
      return BQ_AWS_PERSONALIZE_LOGIC_TYPE
    },
    BQ_AWS_PERSONALIZE_PAGE_TYPE() {
      return BQ_AWS_PERSONALIZE_PAGE_TYPE
    },
    BQ_AWS_PERSONALIZE_AREA_NAME() {
      return BQ_AWS_PERSONALIZE_AREA_NAME
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
  mounted() {
    eventBus.$on(APP_EVENTS.SHOW_PRODUCT_RECOMANDATION, (id: string) => {
      scrollTo(0, 500)
      if (this.currentId !== id) {
        this.isLoading = true
        this.isShow = true
        this.loadRecommendedProductsOnOrderHistory()
        this.currentId = id
      }
    })
  },
  methods: {
    closeModal() {
      this.isShow = false
      this.currentId = ''
    },
    recommendedProductsSwiperOptions(classifier: string) {
      return {
        spaceBetween: 34,
        loop: false,
        navigation: {
          nextEl: `.${classifier} .tks-RecommendedProducts_PaginationBtnNext`,
          prevEl: `.${classifier} .tks-RecommendedProducts_PaginationBtnPrev`
        }
      }
    },
    async loadRecommendedProductsOnOrderHistory() {
      const numberOfProducts = 16
      await apolloClient
        .query({
          query: recommendedProductsQuery,
          variables: {
            offset: 0,
            limit: numberOfProducts,
            awsPersonalize: {
              numResults: numberOfProducts,
              pattern: PERSONALIZE_PATTERNS.PATTERN_A,
              pageType: PERSONALIZE_PAGES.PRODUCT_DETAIL,
              pageArea: PERSONALIZE_AREAS.TOP_SIDE
            }
          }
        })
        .then(response => {
          const data = response.data.recommendedProducts
          this.recommendedProductsOnOrderHistory = checkCache(data.items)
          this.isLoading = false
        })
        .catch(error => {
          if (error?.length > 0) {
             alert(error || SYSTEM_ERROR.UNKNOWN)
          }
        })
    }
  }
})
